import { createActions } from 'reduxsauce';

const { Types, Creators} = createActions({
  sendNotification: ['params'],
  sendNotificationSuccess: ['NotificationResult']
});
export const NotificationTypes = Types;
export default Creators;
